import React, { memo } from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function BeforeAfterSection() {
  const comparisons = [{
    before: 'Memorizar significados de memoria sin entenderlos.',
    after: 'Comprender el viaje del Tarot de forma intuitiva.'
  }, {
    before: 'Dudar en cada carta y buscar en Google.',
    after: 'Conectar las cartas con fluidez y seguridad.'
  }, {
    before: 'Miedo a equivocarte al leerle a otros.',
    after: 'Confianza total en tus lecturas y mensajes.'
  }, {
    before: 'Lecturas superficiales y confusas.',
    after: 'Respuestas profundas, claras y terapéuticas.'
  }, {
    before: 'No saber cómo estructurar una sesión.',
    after: 'Sesiones profesionales guiadas paso a paso.'
  }];
  return <section className="px-4 py-12 pt-[1px] pb-[1px] pl-[1px] pr-[1px]" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <h2 className="mb-6 text-3xl font-bold text-center md:text-4xl text-brand-teal" data-id="element-18">
          El cambio que vas a notar en tus lecturas
        </h2>

        <div className="grid grid-cols-2 gap-x-4 md:gap-x-8 mb-2" data-id="element-19">
          <div className="flex items-center gap-2 pb-3 border-b border-brand-amber/30" data-id="element-20">
            <XCircleIcon className="w-5 h-5 text-brand-amber shrink-0" data-id="element-21" />
            <span className="text-lg font-bold text-brand-amber" data-id="element-22">ANTES</span>
          </div>
          <div className="flex items-center gap-2 pb-3 border-b border-brand-teal/30" data-id="element-23">
            <CheckCircle2Icon className="w-5 h-5 text-brand-teal shrink-0" data-id="element-24" />
            <span className="text-lg font-bold text-brand-teal" data-id="element-25">DESPUÉS</span>
          </div>
        </div>

        <div className="divide-y divide-brand-teal/10" data-id="element-26">
          {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 gap-x-4 md:gap-x-8 py-3" data-id="element-27">
              <p className="text-sm text-brand-dark/60 line-through decoration-brand-amber/40" data-id="element-28">
                {item.before}
              </p>
              <p className="text-sm text-brand-dark font-medium" data-id="element-29">
                {item.after}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}